<template>
<transition name="fade" appear>
  <div class="close-icon-container">
    <div class="close-icon" @click="click">
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 19 19">
        <g fill="none" stroke="#141414" stroke-linecap="round" stroke-linejoin="round" stroke-miterlimit="10" stroke-width=".5">
          <circle cx="9.5" cy="9.5" r="9.1"/>
          <path d="M14.4 14.4L4.5 4.5M4.5 14.4l9.9-9.9"/>
        </g>
      </svg>
    </div>
  </div>
</transition>
</template>
<script>
export default {
  methods: {
    click () {
      this.$emit('close')
    }
  }
}
</script>
